import type { TextStyle } from 'react-native'

import type { useTheme } from './restyle'

/**
 * The body text style as a `TextInput` should take it: without `lineHeight`.
 *
 * iOS lays a single-line input's text and its placeholder out differently once
 * a line height is set — the placeholder drops to the line box's baseline while
 * typed text is pinned to its top — so the two sit at different heights and the
 * field appears to jump as the first character lands. The box's own centring
 * is what holds the text in place; the line height only fought it.
 */
export function inputTextStyle(theme: ReturnType<typeof useTheme>): TextStyle {
  const { lineHeight: _lineHeight, ...text } = theme.textVariants.body
  return text
}
